module.exports = __webpack_public_path__ + "static/media/wallet_blue_badge.4a8326d6.svg";